import { createSlice } from '@reduxjs/toolkit'
import { Person } from '../../../model/person.model'
import { getPersonFullName } from '../../../util/getPersonName'

const employeesSlice = createSlice({
  name: 'employees',
  initialState: [] as Person[],
  reducers: {
    allEmployeesSet: (state, action) => {
      return action.payload
    },
    employeeAdded: (state, action) => {
      action.payload.full_name = getPersonFullName(action.payload)
      state.push(action.payload)
    },
    employeeUpdated: (state, action) => {
      return state.map((item) => {
        if (item.person_id !== action.payload.person_id) {
          // This isn't the item we care about - keep it as-is
          return item
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...item,
          ...action.payload,
        }
      })
    },
    employeeRemoved: (state, action) => {
      state.filter((person) => person.person_id !== action.payload)
    },
  },
})

export const {
  allEmployeesSet,
  employeeAdded,
  employeeUpdated,
  employeeRemoved,
} = employeesSlice.actions

export default employeesSlice.reducer